import React, { useContext, useRef, useState } from "react";
import {
  Button,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { CreateOfferContext } from "./context";
import GrantsOneTime from "./GrantsOneTime";
import GrantsRecurring from "./GrantsRecurring";
import { tabChange } from "../../Utils/SetDefaultRowData";
import { isEmptyorInvalidFieldForGrantsAndCharges } from "./constants/checkEmptyFields";

const Grants = () => {
  const {
    isSubscribed,
    values,
    touched,
    setTouched,
    overrideState,
    recurringFrequencyOptions,
    overrideStateRecurring,
    prorateState,
    activeTab,
    setActiveTab,
  } = useContext(CreateOfferContext);
  const pushOneTimeRef = useRef(null);
  const pushRecurringRef = useRef(null);

  return (
    <Row className="mb-4">
      <Col lg={12}>
        {values?.grants?.length === 0 &&
        values?.recurringGrants?.length === 0 ? (
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ marginTop: "120px" }}
          >
            {isSubscribed ? (
              <div className="text-center mb-2">
                There are no Grants available for this offer.
              </div>
            ) : (
              <div className="text-center mb-2">
                There are no Grants available for this offer, Add a Grant to
                proceed.
              </div>
            )}

            {!isSubscribed && (
              <Button
                color="secondary"
                className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 text-nowrap mt-0"
                onClick={() => {
                  const lastIndex = values.grants.length - 1;
                  if (
                    lastIndex === -1 ||
                    !isEmptyorInvalidFieldForGrantsAndCharges(
                      lastIndex,
                      values.grants
                    )
                  ) {
                    pushOneTimeRef.current &&
                      pushOneTimeRef.current({
                        resourceType: "",
                        resourceValue: "0",
                        ceiling: "",
                        floor: "",
                        validityStartsOn: "",
                        validityEndsOn: "",
                        override: overrideState,
                        prorate: false,
                        type: "1",
                        recurringFrequency: { value: "0", label: "false" },
                      });
                    setTouched({
                      ...touched,
                      grants: {
                        ...touched.grants,
                        [lastIndex]: {
                          resourceType: false,
                        },
                      },
                    });
                  }
                }}
              >
                <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i>
                <span className="px-0 ps-2 ms-2 me-1">Add Grant</span>
              </Button>
            )}
          </div>
        ) : (
          <div className="rv-nav d-flex flex-wrap flex-lg-nowrap align-items-center">
            <Nav
              role="tablist"
              className="ms-3 me-1 flex-grow-1 d-flex flex-wrap"
            >
              <NavItem>
                <NavLink
                  className={activeTab === "1" ? "active" : ""}
                  onClick={() => {
                    tabChange("1", activeTab, setActiveTab);
                  }}
                  type="button"
                >
                  {/* <OneTimeIcon /> */}
                  <span className="ms-2">One Time</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="#"
                  className={activeTab === "2" ? "active" : ""}
                  onClick={() => {
                    tabChange("2", activeTab, setActiveTab);
                  }}
                  type="button"
                >
                  {/* <RecurringIcon /> */}
                  <span className="ms-2">Recurring</span>
                </NavLink>
              </NavItem>
              {!isSubscribed &&
                (activeTab === "1" ? (
                  <Button
                    color="secondary"
                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-0 text-nowrap mb-1 ms-auto"
                    onClick={() => {
                      const lastIndex = values.grants.length - 1;
                      if (
                        lastIndex === -1 ||
                        !isEmptyorInvalidFieldForGrantsAndCharges(
                          lastIndex,
                          values.grants
                        )
                      ) {
                        pushOneTimeRef.current &&
                          pushOneTimeRef.current({
                            resourceType: "",
                            resourceValue: "0",
                            ceiling: "",
                            floor: "",
                            validityStartsOn: "",
                            validityEndsOn: "",
                            override: overrideState,
                            prorate: false,
                            type: "1",
                            recurringFrequency: { value: "0", label: "false" },
                          });
                        setTouched({
                          ...touched,
                          grants: {
                            ...touched.grants,
                            [lastIndex]: {
                              resourceType: false,
                            },
                          },
                        });
                      }
                    }}
                  >
                    {" "}
                    <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i>{" "}
                    <span className="px-0 ps-2 ms-2 me-1">Add Grant </span>
                  </Button>
                ) : (
                  <Button
                    color="secondary"
                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-0 text-nowrap mb-1 ms-auto"
                    onClick={() => {
                      const lastIndex = values.recurringGrants.length - 1;
                      if (
                        lastIndex === -1 ||
                        !isEmptyorInvalidFieldForGrantsAndCharges(
                          lastIndex,
                          values.recurringGrants
                        )
                      ) {
                        pushRecurringRef.current &&
                          pushRecurringRef.current({
                            recurringFrequency: recurringFrequencyOptions[0],
                            recurringFrequencyUnit: 1,
                            resourceType: "",
                            resourceValue: "0",
                            infinite: "",
                            ceiling: "",
                            floor: "",
                            grantValidityEndsOnTimeperiod: "",
                            type: "2",
                            override: overrideStateRecurring,
                            prorate: prorateState,
                            validityStartsOn: "",
                            validityEndsOn: "",
                            cycleAlignment: {
                              value: 1,
                              label: "Billing Cycle",
                            },
                            rollover: false,
                            rolloverModel: {
                              rolloverAmount: 0,
                              rolloverCycle: 0,
                              rolloverPriority: false,
                            },
                          });
                        setTouched({
                          ...touched,
                          recurringGrants: {
                            ...touched.recurringGrants,
                            [lastIndex]: {
                              resourceType: false,
                            },
                          },
                        });
                      }
                    }}
                  >
                    {" "}
                    <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i>{" "}
                    <span className="px-0 ps-2 ms-2 me-1">Add Grant </span>
                  </Button>
                ))}
            </Nav>
          </div>
        )}
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <GrantsOneTime pushRef={pushOneTimeRef} />
          </TabPane>
          <TabPane tabId="2">
            <GrantsRecurring pushRef={pushRecurringRef} />
          </TabPane>
        </TabContent>
      </Col>
    </Row>
  );
};

export default Grants;
